
const ownersAssemblyRecordView = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownersAssemblyRecordView')), 'ownersAssemblyRecordView');
const ownersAssemblyRecord = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/addOwnersAssemblyRecord/ownersAssemblyRecord')), 'ownersAssemblyRecord');
const ownerCommitteeRecordAccept = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeRecordAccept/ownerCommitteeRecordAccept')), 'ownerCommitteeRecordAccept');
const ownerCommitteeRecordDetail = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeRecordDetail/ownerCommitteeRecordDetail')), 'ownerCommitteeRecordDetail');
const ownerCommitteeExamination = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeExamination/ownerCommitteeExamination')), 'ownerCommitteeExamination');
const ownerCommitteeRecordCensor = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeRecordCensor/ownerCommitteeRecordCensor')), 'ownerCommitteeRecordCensor');
const conferenceRecordList = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/conferenceRecordList/conferenceRecordList')), 'conferenceRecordList');
const memberMaintain = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/memberMaintain/memberMaintain')), 'memberMaintain');

const ownerCommitteeChangeRecord = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeChangeRecord/ownerCommitteeChangeRecord')), 'ownerCommitteeChangeRecord');

const ownersAssemblyRecordRouter = {
    path: '',
    name: '备案管理',
    component: ownersAssemblyRecordView,
    meta:{icon:'ownersAssemblyRecord',right:[],isShowMenu:true,keepAlive: true,},
    children: [


        {path: '/ownerCommitteeRecord', component: ownersAssemblyRecord, name: '业委会备案', meta: {right:[],isShowMenu:true,keepAlive:true},workTemplateName: '业主委员会备案'},
        // {path: '/hashaOwnerCommitteeRecord', name: '业委会备案', meta: {right:[],isShowMenu:true,workflow: true,workTemplateName: '业主委员会备案'},},
        {path: '/ownerCommitteeRecordAccept', component: ownerCommitteeRecordAccept, name: '业委会受理', meta: {right:[],isShowMenu:true,keepAlive:true},},
        {path: '/ownerCommitteeExamination', component:ownerCommitteeExamination , name: '业委会审查', meta: {right:[],isShowMenu:true,worktype:true,keepAlive:true},},
        {path: '/ownerCommitteeRecordCensor', component:ownerCommitteeRecordCensor , name: '业委会审核', meta: {right:[],isShowMenu:true,keepAlive:true},},
        {path: '/conferenceRecordList', component:conferenceRecordList , name: '会议管理', meta: {right:[],isShowMenu:true,keepAlive:true},},
        {path: '/memberMaintain', component:memberMaintain , name: '成员管理', meta: {right:[],isShowMenu:true,keepAlive:true},},

        //{path: '/ownerCommitteeChangeRecord', component: ownerCommitteeChangeRecord, name: '业委会变更备案', meta: {right:[],isShowMenu:false}},
        //{path: '/ownerCommitteeChangeRecordasdad', name: '业委会变更备案', meta: {right:[],isShowMenu:true,workflow: true,workTemplateName: '业委会变更备案'},},
        {
            path: '/ownerCommitteeChangeRecord',
            component: ownerCommitteeChangeRecord,
            name: '业委会变更备案',
            meta: {
              right: [],
              isShowMenu: true,
                keepAlive:true
            },
          }, 
          {
            path: '/ownerCommitteeChangeRecordsaad',
            name: '业委会变更备案',
            meta: {
              right: [],
              isShowMenu: true,
              workflow: true,
              workTemplateName: '业委会变更备案',
                keepAlive:true
            },
          },
          {
            path: '/ownerCommitteeRecordDetail',
            component: ownerCommitteeRecordDetail,
            name: '业委会备案详情',
            meta: {
              right: [],
              isShowMenu: true,
                keepAlive:true
            },
          },   
    
    ]
};


export default ownersAssemblyRecordRouter;
